module.exports = __webpack_public_path__ + "img/washer-icon.92ac66bc.svg";